<template>
  <div class="token-body">
    <div class="token-table">
      <div class="token-title">水龙头列表</div>

      <div class="token-div">
        <ul class="token-ul" v-for="items in tokenConfigs" :key="items.key">
          <div class="tokne-desc">{{ items.desc }}</div>
          <div class="tokne-hr"></div>
          <li
            class="token-li"
            v-for="(item, index) in items.listData"
            :key="index"
          >
            <div class="token-url">{{ item.url }}</div>
            <div class="token-mark">
              <div v-if="item.mark">{{ item.mark }}</div>
            </div>
            <div class="token-btn">
              <div class="btn" @click="receive(item.url)">前往领取</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { tokenConfigs } from "@/config/faucet.js";

export default {
  data() {
    return {
      tokenConfigs: tokenConfigs,
    };
  },
  methods: {
    receive(url) {
        window.open(url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.token-body {
  width: calc(100% - 16%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0 8% 0 8%;

  .token-table {
    width: 100%;
    height: 100%;

    .token-title {
      font-weight: normal;
      font-size: 20px;
      color: #8f8f8f;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 54px 0 20px 0;
    }

    .token-div {
      width: 100%;
      height: auto;
      overflow: auto;

      .token-ul {
        background: #292929;
        border-radius: 8px 8px 8px 8px;
        border: 2px solid rgb(39, 39, 39);

        margin: 0 0 20px 0;
        padding: 20px 20px;

        .tokne-desc {
          font-weight: normal;
          font-size: 24px;
          color: rgb(245, 245, 245);
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .tokne-hr {
          background-color: rgb(114, 112, 112);
          height: 1px;
          margin: 10px 0;
        }

        .token-li {
          display: flex;
          align-items: center;
          margin: 12px 0;
          height: 32px;

          .token-url {
            flex: 2;
            font-weight: normal;
            font-size: 17px;
            color: #7369db;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .token-mark {
            flex: 2;
            color: #f5f5f5;
            font-size: 14px;
          }

          .token-btn {
            flex: 1;

            .btn {
              width: 100px;
              height: 23px;
              // background: #7369db;
              border-radius: 30px 30px 30px 30px;
              border: 1px solid #7369db;
               border: 1px solid #fff;

              font-weight: normal;
              font-size: 14px;
              color: #ffffff;
              line-height: 23px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              cursor: pointer;
            }

            .btn:hover {
              border: 1px solid #aba4ff;
            }
          }
        }

        .token-li:hover {
          background: rgba(77,77,77,0.5);

          .token-url {
            color: #D8D8D8;
          }
        }
      }
    }
  }
}
/* 为所有滚动条设置样式 */
::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
  height: 10px; /* 设置滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent; /* 设置轨道的背景颜色 */
}

/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 设置滑块的背景颜色 */
  border-radius: 5px 5px;
}

/* 当鼠标悬停在滑块上 */
::-webkit-scrollbar-thumb:hover {
  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
  cursor: pointer;
}
</style>